import type { TrainingLessonSpecific } from './trainingLessonUi';

export const elder1MinistrationEs: TrainingLessonSpecific = {
  intro:
    'El Elder ministra, bendice con fe y reverencia, y coordina con líderes. La fe del que bendice importa, pero también la del que recibe. Ministrar es constancia, no eventos aislados.',
  objectives: [
    'Entender el rol del Elder en ministración.',
    'Aprender a dar bendiciones con fe y reverencia.',
    'Coordinar con líderes.',
    'Desarrollar hábitos de dignidad continua.',
    'Plan semanal de ministración.',
  ],
  briefHeading: 'Ministración en breve',
  briefBody:
    'Las bendiciones, visitas y oraciones se ofrecen con humildad, bajo la dirección de quien posee las llaves cuando aplica. La ministración fiel edifica barrios y familias.',
  scriptures: [
    { ref: 'DyC 20:38–45', text: 'Deberes del Elder: predicar, enseñar, bautizar, confirmar, administrar la Santa Cena.' },
    { ref: 'Santiago 5:14–15', text: 'Los ancianos de la iglesia oren sobre él, ungiéndole con aceite en el nombre del Señor.' },
    { ref: 'DyC 42:44', text: 'Los élderes oran e imponen manos en el nombre del Señor.' },
    { ref: 'DyC 107:12', text: 'El oficio de Elder es administrar en las cosas espirituales.' },
    { ref: 'Marcos 16:18', text: 'Impondrán las manos sobre los enfermos y sanarán.' },
  ],
  didYouKnow: [
    'La fe del que bendice importa, pero también la del que recibe.',
    'Ministrar es constancia, no eventos aislados.',
  ],
  practiceItems: [
    'Preparación espiritual antes de oficiar (oración, dignidad)',
    'Pedir permiso antes de dar una bendición (a quien preside o a la familia)',
    'Usar palabras claras y reverentes al bendecir',
    'Coordinar con líderes para visitas de ministración',
    'Hacer seguimiento después de una bendición o visita',
    'Anotar en un diario: una experiencia de ministración esta semana',
  ],
  reflectionQuestions: [
    '¿Qué me frena al ministrar o dar bendiciones?',
    '¿Cómo puedo coordinar mejor con líderes y compañeros?',
    '¿Cómo puedo crecer en fe para bendecir?',
  ],
  actionText: 'Una visita de ministración con propósito.',
};
